import "../assets/StickyImage.css";
import { defineComponent as T, useCssVars as ee, unref as s, ref as c, computed as a, watchEffect as O, openBlock as f, createBlock as x, Transition as v, withCtx as p, withDirectives as m, createElementVNode as u, createVNode as t, vShow as h, createElementBlock as le, withModifiers as re, createCommentVNode as D, defineAsyncComponent as se, onMounted as ve, Fragment as fe, normalizeClass as Q, normalizeStyle as ue, TransitionGroup as ce, provide as ge } from "vue";
import { D as $, h as X, f as N, a as de, e as G } from "./maps.BMuTsKez.js";
import { u as oe } from "./index.AJuLibkw.js";
import { r as ke } from "./CrossIcon.Buquwi_L.js";
import { d as pe } from "./debounce.F9gDQpy6.js";
import { b as Z, l as H, t as xe, _ as we, h as U } from "./useStore.CNSXUGVb.js";
import { a as B, m as b, t as ye } from "./useModal.CgbJKM9V.js";
import { _ as A } from "./XClose.vue_vue_type_style_index_0_lang.DUo_9CFc.js";
import { _ as F } from "./Overlay.vue_vue_type_style_index_0_lang.kb4jQJDQ.js";
import { _ as V } from "./Back.vue_vue_type_style_index_0_lang.DIIXYzeh.js";
import { _ as L } from "./Steps.vue_vue_type_style_index_0_lang.BlOYWakS.js";
import { _ as q } from "./Modal.vue_vue_type_style_index_0_lang.Cj18WwJH.js";
import { _ as Ie, u as ze, a as me, r as he } from "./useImageStyles.CHL0VDP2.js";
import { _ as je } from "./_plugin-vue_export-helper.CHgC5LLL.js";
import { b as be } from "./Text.vue_vue_type_style_index_0_lang.B5gHH0dB.js";
import { _ as Ce } from "./Icon.vue_vue_type_style_index_0_lang.B5VfXFGt.js";
const Se = { class: "thn--tool-circular__content" }, De = { class: "thn--tool-circular__popup" }, $e = 530, vo = /* @__PURE__ */ T({
  __name: "Circular",
  props: {
    language: {},
    device: {},
    steps: {},
    hasSteps: {},
    layout: {}
  },
  setup(I, { expose: z }) {
    ee((S) => ({
      "5b80fec0": s(Z)(r.value)
    }));
    const o = pe(ye, 200, { leading: !0, trailing: !1 }), e = I, n = H(), i = c(!1), l = c(!1), d = c(), { width: _, height: y } = oe(d), r = a(() => {
      const S = Math.min(_.value, y.value);
      return Math.min($e, S * 0.9);
    }), g = a(() => r.value), w = a(() => !!e.layout.closeOnClickOutside);
    O(() => {
      n == null || n.styles.addCssVariables(
        n.literals.device === $.Desktop ? {
          "--step-padding": "100px 75px 100px 60px",
          "--module-margin-top": "20px",
          "--xclose-margin": "0px"
        } : {
          "--step-padding": "70px 45px 40px 25px",
          "--module-margin-top": "15px",
          "--xclose-margin": "5px"
        }
      );
    });
    function C() {
      i.value = !1;
    }
    function j() {
      i.value = !0;
    }
    function E() {
      l.value = !0;
    }
    return z({
      show: C,
      hide: j
    }), (S, M) => (f(), x(v, {
      name: "fade",
      appear: "",
      onAfterEnter: E
    }, {
      default: p(() => [
        m(u("div", {
          class: "thn--tool-circular",
          ref_key: "rootDom",
          ref: d
        }, [
          t(F, {
            class: "thn--tool-circular__overlay",
            "close-on-click-outside": w.value
          }, null, 8, ["close-on-click-outside"]),
          u("div", Se, [
            t(v, { name: "fade-from-bottom" }, {
              default: p(() => [
                m(u("div", De, [
                  t(V, { class: "thn--tool-circular__back" }),
                  t(L, {
                    class: "thn--tool-circular__steps",
                    steps: e.steps,
                    "has-extra-steps": e.hasSteps,
                    "max-height": g.value
                  }, null, 8, ["steps", "has-extra-steps", "max-height"]),
                  t(v, { name: "fade" }, {
                    default: p(() => [
                      m(t(q, { "terms-text": s(B) }, null, 8, ["terms-text"]), [
                        [h, s(b)]
                      ])
                    ]),
                    _: 1
                  })
                ], 512), [
                  [h, !i.value && l.value]
                ])
              ]),
              _: 1
            }),
            t(v, { name: "fade" }, {
              default: p(() => [
                m(t(A, null, null, 512), [
                  [h, !i.value && !s(b) && l.value]
                ])
              ]),
              _: 1
            }),
            t(v, { name: "fade" }, {
              default: p(() => [
                s(b) ? (f(), le("div", {
                  key: 0,
                  class: "thn--tool-xclose thn--tool-xclose--modal",
                  onMousedown: M[0] || (M[0] = re(
                    //@ts-ignore
                    (...k) => s(o) && s(o)(...k),
                    ["left"]
                  )),
                  onClick: M[1] || (M[1] = //@ts-ignore
                  (...k) => s(o) && s(o)(...k))
                }, [
                  t(s(ke), { class: "thn--tool-xclose__svg" })
                ], 32)) : D("", !0)
              ]),
              _: 1
            })
          ])
        ], 512), [
          [h, !i.value]
        ])
      ]),
      _: 1
    }));
  }
}), Me = {
  class: "thn--tool__popup thn--tool-custom-content",
  "data-add-module": !0
}, Ee = /* @__PURE__ */ T({
  __name: "CustomImage",
  props: {
    language: {},
    device: {},
    steps: {},
    layout: {}
  },
  setup(I, { expose: z }) {
    const o = I, e = H(), n = c(), i = c(!1), { width: l, height: d } = oe(n), _ = a(() => !!o.layout.closeOnClickOutside), y = a(() => o.steps[X.Main][0]), r = a(() => {
      if (l.value) {
        const j = (e == null ? void 0 : e.literals.device) === $.Mobile ? 0.9 : 0.8;
        return l.value * j;
      }
      return 300;
    }), g = a(() => {
      if (d.value) {
        const j = (e == null ? void 0 : e.literals.device) === $.Mobile ? 0.9 : 0.8;
        return d.value * j;
      }
      return 300;
    });
    function w() {
      i.value = !1;
    }
    function C() {
      i.value = !0;
    }
    return O(() => {
      e == null || e.styles.addCssVariables(
        e.literals.device === $.Desktop ? {
          "--module-margin-top": "20px",
          "--xclose-margin": "10px"
        } : {
          "--module-margin-top": "15px",
          "--xclose-margin": "5px"
        }
      );
    }), z({
      show: w,
      hide: C
    }), (j, E) => (f(), x(v, {
      name: "fade",
      appear: ""
    }, {
      default: p(() => [
        m(u("div", {
          class: "thn--tool-custom-image",
          ref_key: "rootDom",
          ref: n
        }, [
          t(F, {
            class: "thn--tool-custom-image__overlay",
            "close-on-click-outside": _.value
          }, null, 8, ["close-on-click-outside"]),
          u("div", Me, [
            t(Ie, {
              class: "thn--tool-custom-image__image",
              "module-props": y.value,
              "max-width": r.value,
              "max-height": g.value
            }, null, 8, ["module-props", "max-width", "max-height"]),
            t(A)
          ])
        ], 512), [
          [h, !i.value]
        ])
      ]),
      _: 1
    }));
  }
}), fo = /* @__PURE__ */ je(Ee, [["__scopeId", "data-v-2c97b815"]]), Oe = { class: "thn--tool-fullscreen__popup" }, go = /* @__PURE__ */ T({
  __name: "Fullscreen",
  props: {
    language: {},
    device: {},
    steps: {},
    hasSteps: {},
    layout: {}
  },
  setup(I, { expose: z }) {
    const o = I, e = H(), n = c(!1), i = c(!1), l = c(), d = a(() => {
      if (l.value)
        return l.value.offsetHeight;
    }), _ = a(() => o.layout.closeOnClickOutside);
    O(() => {
      e == null || e.styles.addCssVariables(
        e.literals.device === $.Desktop ? {
          "--step-padding": "40px",
          "--module-margin-top": "20px",
          "--xclose-margin": "10px"
        } : {
          "--step-padding": "25px",
          "--module-margin-top": "15px",
          "--xclose-margin": "5px"
        }
      );
    });
    function y() {
      n.value = !1;
    }
    function r() {
      n.value = !0;
    }
    function g() {
      i.value = !0;
    }
    return z({
      show: y,
      hide: r
    }), (w, C) => (f(), x(v, {
      name: "fade",
      appear: "",
      onAfterEnter: g
    }, {
      default: p(() => [
        m(u("div", {
          class: "thn--tool-fullscreen",
          ref_key: "rootDom",
          ref: l
        }, [
          t(F, {
            class: "thn--tool-fullscreen__overlay",
            "close-on-click-outside": !!_.value
          }, null, 8, ["close-on-click-outside"]),
          t(v, { name: "fade-from-bottom" }, {
            default: p(() => [
              m(u("div", Oe, [
                t(L, {
                  class: "thn--tool-fullscreen__steps",
                  steps: o.steps,
                  "has-extra-steps": o.hasSteps,
                  "max-height": d.value
                }, null, 8, ["steps", "has-extra-steps", "max-height"]),
                t(v, { name: "fade" }, {
                  default: p(() => [
                    m(t(q, { "terms-text": s(B) }, null, 8, ["terms-text"]), [
                      [h, s(b)]
                    ])
                  ]),
                  _: 1
                })
              ], 512), [
                [h, !n.value && i.value]
              ])
            ]),
            _: 1
          }),
          s(b) ? D("", !0) : (f(), x(A, { key: 0 }))
        ], 512), [
          [h, !n.value]
        ])
      ]),
      _: 1
    }));
  }
}), Te = ["data-device"], ko = /* @__PURE__ */ T({
  __name: "FullscreenMini",
  props: {
    language: {},
    device: {},
    steps: {},
    hasSteps: {},
    layout: {}
  },
  setup(I, { expose: z }) {
    const o = I, e = H(), n = c(!1), i = c(!1), l = c(), d = a(() => {
      if (l.value)
        return l.value.offsetHeight;
    }), _ = a(() => o.layout.closeOnClickOutside);
    O(() => {
      e == null || e.styles.addCssVariables(
        e.literals.device === $.Desktop ? {
          "--step-padding": "20px",
          "--module-margin-top": "20px",
          "--xclose-margin": "10px"
        } : {
          "--step-padding": "25px",
          "--module-margin-top": "15px",
          "--xclose-margin": "5px"
        }
      );
    });
    function y() {
      n.value = !1;
    }
    function r() {
      n.value = !0;
    }
    function g() {
      i.value = !0;
    }
    return z({
      show: y,
      hide: r
    }), (w, C) => (f(), x(v, {
      name: "fade",
      appear: "",
      onAfterEnter: g
    }, {
      default: p(() => [
        m(u("div", {
          class: "thn--tool-fullscreen-mini",
          ref_key: "rootDom",
          ref: l
        }, [
          t(F, {
            class: "thn--tool-fullscreen-mini__overlay",
            "close-on-click-outside": !!_.value
          }, null, 8, ["close-on-click-outside"]),
          t(v, { name: "fade-from-bottom" }, {
            default: p(() => {
              var j;
              return [
                m(u("div", {
                  class: "thn--tool-fullscreen-mini__popup",
                  "data-device": (j = s(e)) == null ? void 0 : j.literals.device
                }, [
                  t(L, {
                    class: "thn--tool-fullscreen-mini__steps",
                    steps: o.steps,
                    "has-extra-steps": o.hasSteps,
                    "max-height": d.value
                  }, null, 8, ["steps", "has-extra-steps", "max-height"]),
                  t(v, { name: "fade" }, {
                    default: p(() => [
                      m(t(q, { "terms-text": s(B) }, null, 8, ["terms-text"]), [
                        [h, s(b)]
                      ])
                    ]),
                    _: 1
                  })
                ], 8, Te), [
                  [h, !n.value && i.value]
                ])
              ];
            }),
            _: 1
          }),
          s(b) ? D("", !0) : (f(), x(A, { key: 0 }))
        ], 512), [
          [h, !n.value]
        ])
      ]),
      _: 1
    }));
  }
}), He = ["data-device"], xo = /* @__PURE__ */ T({
  __name: "LowerNotification",
  props: {
    language: {},
    device: {},
    steps: {},
    hasSteps: {},
    layout: {}
  },
  setup(I, { expose: z }) {
    const o = I, e = H(), n = c(!1), i = c(), l = a(() => (e == null ? void 0 : e.handlers.stepActive) || X.Main), d = a(() => (e == null ? void 0 : e.literals.device) === $.Mobile), _ = a(() => o.steps[X.Main].filter(
      (S) => S.moduleType !== N.Icon
    ).length), y = a(() => o.steps[X.Main].find(
      (S) => S.moduleType === N.Icon
    )), r = a(() => o.steps[l.value].find(
      (S) => S.moduleType === N.Button
    )), g = a(() => !!o.steps[X.Main].find(
      (S) => S.moduleType === N.Form
    )), w = a(() => Object.keys(o.steps).reduce((M, k) => (M[k] = o.steps[k].filter(
      (R) => R.moduleType !== N.Icon && R.moduleType !== N.Button || R.moduleType !== N.Icon && _.value > 4 || R.moduleType !== N.Icon && g.value || d.value
    ), M), {})), C = a(() => {
      if (i.value)
        return d.value ? 0 : 270;
    });
    O(() => {
      e == null || e.styles.addCssVariables(
        d.value ? {
          "--step-padding": "5px",
          "--module-margin-top": "10px",
          "--xclose-margin": "5px"
        } : {
          "--module-margin-top": "10px",
          "--step-padding": `5px 15px 10px ${y.value ? 20 : 0}px`,
          "--xclose-margin": "7px"
        }
      );
    });
    function j() {
      n.value = !1;
    }
    function E() {
      n.value = !0;
    }
    return z({
      show: j,
      hide: E
    }), (S, M) => (f(), x(v, {
      name: "fade-from-bottom",
      appear: ""
    }, {
      default: p(() => {
        var k;
        return [
          m(u("div", {
            class: "thn--tool-lower-notification",
            ref_key: "rootDom",
            ref: i
          }, [
            u("div", {
              class: "thn--tool-lower-notification__popup",
              "data-device": (k = s(e)) == null ? void 0 : k.literals.device
            }, [
              t(V, { class: "thn--tool-lower-notification__back" }),
              y.value && !d.value ? (f(), x(Ce, {
                key: 0,
                class: "thn--tool-lower-notification__icon",
                "module-props": y.value
              }, null, 8, ["module-props"])) : D("", !0),
              t(L, {
                class: "thn--tool-lower-notification__steps",
                steps: w.value,
                "has-extra-steps": o.hasSteps,
                "max-height": C.value,
                "layout-kind": s(de).LowerNotification
              }, null, 8, ["steps", "has-extra-steps", "max-height", "layout-kind"]),
              r.value && !d.value && _.value <= 4 && !g.value ? (f(), x(be, {
                key: 1,
                class: "thn--tool-lower-notification__button",
                "module-props": r.value,
                "has-extra-steps": o.hasSteps,
                "data-module-id": r.value.id,
                "data-module-special": !0
              }, null, 8, ["module-props", "has-extra-steps", "data-module-id"])) : D("", !0),
              s(b) ? D("", !0) : (f(), x(A, {
                key: 2,
                class: "thn--tool-lower-notification__xclose"
              })),
              t(v, { name: "fade" }, {
                default: p(() => [
                  m(t(q, { "terms-text": s(B) }, null, 8, ["terms-text"]), [
                    [h, s(b)]
                  ])
                ]),
                _: 1
              })
            ], 8, He)
          ], 512), [
            [h, !n.value]
          ])
        ];
      }),
      _: 1
    }));
  }
}), Ae = ["data-position"], Pe = ["data-closed"], Be = ["data-show-number", "disabled"], ne = 40, ae = 0.6, ie = 620, wo = /* @__PURE__ */ T({
  __name: "NotificationTab",
  props: {
    language: {},
    device: {},
    steps: {},
    hasSteps: {},
    layout: {}
  },
  setup(I, { expose: z }) {
    ee((P) => ({
      "2b232176": s(Z)(ne),
      "5b54cc10": s(Z)(j.value)
    }));
    const o = I, e = c(!0), n = c(!1), i = c(), { width: l, height: d } = oe(i), _ = H(), y = c(!1), r = a(() => {
      var P;
      return ((P = o.layout.position) == null ? void 0 : P.charAt(0)) === "L";
    }), g = a(() => {
      var P;
      if ((P = o.layout.icon) != null && P.value) {
        const Y = `${xe(o.layout.icon.value)}Icon`;
        return se(() => we(/* @__PURE__ */ Object.assign({ "../../node_modules/@thehotelsnetwork/icons/vue/personalization/AndroidAppleIcon.js": () => import("./AndroidAppleIcon.DE1ALg4F.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/AndroidIcon.js": () => import("./AndroidIcon.DG13Td8x.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/AppleIcon.js": () => import("./AppleIcon.FSFSxBNx.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/AutumnIcon.js": () => import("./AutumnIcon.CIUy4PK_.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/BabyBottleIcon.js": () => import("./BabyBottleIcon.D0Q24ZDf.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/BaliBedIcon.js": () => import("./BaliBedIcon.BnCgTrmJ.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/BathtubIcon.js": () => import("./BathtubIcon.DLzXDysr.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/BeachballIcon.js": () => import("./BeachballIcon.DZ_OleVr.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/BeerIcon.js": () => import("./BeerIcon.aLBm0e3z.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/BellIcon.js": () => import("./BellIcon.c18zrNnj.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/BicycleIcon.js": () => import("./BicycleIcon._AAEmKcr.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/BikeIcon.js": () => import("./BikeIcon.CLGhY54Q.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/BinocularsIcon.js": () => import("./BinocularsIcon.C0e4Geto.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/BoatIcon.js": () => import("./BoatIcon.W6fHp9u9.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/Book2Icon.js": () => import("./Book2Icon.DG4Ca-9T.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/BookIcon.js": () => import("./BookIcon.DaZfjFvH.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/BreadIcon.js": () => import("./BreadIcon.K_unmW80.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/BriefcaseIcon.js": () => import("./BriefcaseIcon.QwKj2cAg.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/BusIcon.js": () => import("./BusIcon.zykXLIKl.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/BusNewIcon.js": () => import("./BusNewIcon.D6xa4_7G.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/BycicleIcon.js": () => import("./BycicleIcon.BmkS7csQ.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/CactusIcon.js": () => import("./CactusIcon.DDd-udBF.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/CakeIcon.js": () => import("./CakeIcon.DUIqhTqy.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/CalendarIcon.js": () => import("./CalendarIcon.CXiZqWLm.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/CameraIcon.js": () => import("./CameraIcon.BW5JWtMq.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/CarIcon.js": () => import("./CarIcon.B2XKNQn3.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/CarNewIcon.js": () => import("./CarNewIcon.5rSthwB6.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/CarrotIcon.js": () => import("./CarrotIcon.CP3lK6hD.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/CheckIcon.js": () => import("./CheckIcon.DGsuGo5Y.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/ChurchIcon.js": () => import("./ChurchIcon.evFhjF9w.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/ClockIcon.js": () => import("./ClockIcon.BO7vIrAl.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/CocktailIcon.js": () => import("./CocktailIcon.Cl4Dmqca.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/CoffeeIcon.js": () => import("./CoffeeIcon.uGV0-PNM.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/CupsIcon.js": () => import("./CupsIcon.Ca4N5Nc7.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/DangerIcon.js": () => import("./DangerIcon.C7KpD7xF.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/DiscountIcon.js": () => import("./DiscountIcon.BrhxasBF.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/DownloadMobileIcon.js": () => import("./DownloadMobileIcon.D9Dko9uf.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/EggIcon.js": () => import("./EggIcon.DO39wzxP.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/EnvelopeIcon.js": () => import("./EnvelopeIcon.1oRsG1Ag.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/FacebookIcon.js": () => import("./FacebookIcon.DDQhg604.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/FamilyIcon.js": () => import("./FamilyIcon.CbiBOU7k.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/FlipFlopsIcon.js": () => import("./FlipFlopsIcon.B01nOeio.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/GhostIcon.js": () => import("./GhostIcon.QYLJmINt.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/GiftIcon.js": () => import("./GiftIcon.Dn7OPlWX.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/GolfIcon.js": () => import("./GolfIcon.xW0zPq99.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/GraphIcon.js": () => import("./GraphIcon.B7xZurbd.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/GraphUpIcon.js": () => import("./GraphUpIcon.B_dGrT3W.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/GymIcon.js": () => import("./GymIcon.Dq3FL5nq.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/HalloweenIcon.js": () => import("./HalloweenIcon.BFgJlnl2.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/HamburgerIcon.js": () => import("./HamburgerIcon.C_AVGUkz.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/HandShakeIcon.js": () => import("./HandShakeIcon.72ML_pDO.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/HashtagIcon.js": () => import("./HashtagIcon.Dxn77_lY.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/HeartIcon.js": () => import("./HeartIcon.C3ZzzYhj.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/HeartsIcon.js": () => import("./HeartsIcon.Do8cC8Pu.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/HeartsNewIcon.js": () => import("./HeartsNewIcon.CIoGFjTc.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/HotelIcon.js": () => import("./HotelIcon.A-xkQ0ra.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/InformationIcon.js": () => import("./InformationIcon.yeOucNQr.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/InstagramIcon.js": () => import("./InstagramIcon.RGanKVxu.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/LastReservationIcon.js": () => import("./LastReservationIcon.CCoBLsuv.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/LastWeekStayedIcon.js": () => import("./LastWeekStayedIcon.UnCUlBpx.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/LaundryIcon.js": () => import("./LaundryIcon.RcLxdRRf.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/LightIcon.js": () => import("./LightIcon.DEWNfuJ5.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/LockGreatPriceIcon.js": () => import("./LockGreatPriceIcon.DroHVd0v.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/MaskIcon.js": () => import("./MaskIcon.yTBGxtEM.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/MusicIcon.js": () => import("./MusicIcon.DT3wWhA0.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/PalmIcon.js": () => import("./PalmIcon.DZdG1TSA.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/ParkingCarIcon.js": () => import("./ParkingCarIcon.B6iUoeWq.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/ParkingPIcon.js": () => import("./ParkingPIcon.BgavIoBu.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/PawIcon.js": () => import("./PawIcon.hCxgQuQE.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/PictureIcon.js": () => import("./PictureIcon.DgB7BITR.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/PinIcon.js": () => import("./PinIcon.jJWTDEFn.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/PizzaIcon.js": () => import("./PizzaIcon.Dd9fyC9q.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/PlaneIcon.js": () => import("./PlaneIcon.C5yvG1O2.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/PlatterIcon.js": () => import("./PlatterIcon.BqKmIBEb.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/PoolIcon.js": () => import("./PoolIcon.i0V0Rmj9.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/PrizeIcon.js": () => import("./PrizeIcon.tBuyQ-Ai.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/RabbitIcon.js": () => import("./RabbitIcon.LU2i48y2.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/RaceIcon.js": () => import("./RaceIcon.L8vPLvb7.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/RelaxIcon.js": () => import("./RelaxIcon.Fd-O7IXQ.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/RestaurantIcon.js": () => import("./RestaurantIcon.DXGdUj28.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/ReviewsIcon.js": () => import("./ReviewsIcon.812OofqQ.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/RoomIcon.js": () => import("./RoomIcon.CCTMJ7cE.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/RoseIcon.js": () => import("./RoseIcon.3-ykFOvU.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/SantaIcon.js": () => import("./SantaIcon.BE3GpFkg.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/SecurePriceDollarIcon.js": () => import("./SecurePriceDollarIcon.Di42Hog4.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/SecurePriceEuroIcon.js": () => import("./SecurePriceEuroIcon.CdfsXAms.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/SecurePriceIcon.js": () => import("./SecurePriceIcon.Di42Hog4.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/SecurePricePoundIcon.js": () => import("./SecurePricePoundIcon.BNzI9eBV.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/SecurePriceYenIcon.js": () => import("./SecurePriceYenIcon.DKpS0ksE.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/ShoppingIcon.js": () => import("./ShoppingIcon.YU-Gqoo1.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/SkiIcon.js": () => import("./SkiIcon.rwTus3gF.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/SnowIcon.js": () => import("./SnowIcon.DzpaMHJh.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/SpacerIcon.js": () => import("./SpacerIcon.BfdptA7K.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/SpecialIcon.js": () => import("./SpecialIcon.BD9Vn4ma.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/StarIcon.js": () => import("./StarIcon.ChquJsvy.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/SunIcon.js": () => import("./SunIcon.W9Fb6vL9.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/SurfIcon.js": () => import("./SurfIcon.Dmy7MxYY.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/ThunderIcon.js": () => import("./ThunderIcon.C9OyT8aj.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/TieIcon.js": () => import("./TieIcon.NS8o2n-k.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/TreeIcon.js": () => import("./TreeIcon.D6xx0l5R.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/TripadvisorIcon.js": () => import("./TripadvisorIcon.C6JbZQnf.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/TrophyIcon.js": () => import("./TrophyIcon.0mSzAJz2.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/TvIcon.js": () => import("./TvIcon.CGwaoxqE.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/UserIcon.js": () => import("./UserIcon.BmJx6C6T.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/UsersIcon.js": () => import("./UsersIcon.hh-A7YZd.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/UsersNewIcon.js": () => import("./UsersNewIcon.BfmqbcfD.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/VirusIcon.js": () => import("./VirusIcon.DGU9m19d.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/VoucherIcon.js": () => import("./VoucherIcon.BhQR6O5r.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/WeddingIcon.js": () => import("./WeddingIcon.Ds8lJd3f.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/WhatsappIcon.js": () => import("./WhatsappIcon.Di4dk98U.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/WheelchairIcon.js": () => import("./WheelchairIcon.Df4mHzDq.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/WifiIcon.js": () => import("./WifiIcon.kvlKU-Qu.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/WineIcon.js": () => import("./WineIcon.Bjf36ik4.js"), "../../node_modules/@thehotelsnetwork/icons/vue/personalization/index.js": () => import("./index.DIqy22Qr.js") }), `../../node_modules/@thehotelsnetwork/icons/vue/personalization/${Y}.js`, 8));
      }
      return null;
    }), w = a(() => se(() => r.value ? import("./ChevronDownIcon.BbXaEdoP.js") : import("./ChevronUpIcon.DnLW3wq_.js")));
    O(() => {
      _ == null || _.styles.addCssVariables(
        _.literals.device === $.Desktop ? {
          "--step-padding": "32px",
          "--module-margin-top": "16px",
          "--xclose-margin": "10px"
        } : {
          "--step-padding": "25px",
          "--module-margin-top": "15px",
          "--xclose-margin": "5px"
        }
      );
    });
    const C = a(() => o.layout.position === "UML" || o.layout.position === "UMR" || o.layout.position === "LML" || o.layout.position === "LMR"), j = a(() => l.value ? l.value - 2 * ne : 0), E = a(() => d.value && C.value ? d.value * ae : d.value ? d.value > ie ? ie : d.value * ae : 0), S = a(() => {
      let P = "up";
      return (r.value && e.value || !r.value && !e.value) && (P = "down"), `fade-tab-icon-${P}`;
    });
    function M() {
      n.value = !1;
    }
    function k() {
      n.value = !0;
    }
    function R() {
      e.value = !1;
    }
    function W() {
      e.value = !0;
    }
    const K = pe(() => {
      e.value = !e.value;
    }, 200, { leading: !0, trailing: !1 });
    function _e() {
      y.value = !0;
    }
    return O(() => {
      _ != null && _.extraData.builderMode && setTimeout(() => {
        e.value = !1;
      }, 500);
    }), ve(() => {
      o.layout.showOpen && setTimeout(() => {
        e.value = !1;
      }, 1e3);
    }), z({
      show: M,
      hide: k,
      open: R,
      close: W
    }), (P, Y) => {
      var te;
      return f(), le(fe, null, [
        u("div", {
          class: "thn--tool-notification-tab__sizer",
          ref_key: "sizerDom",
          ref: i
        }, null, 512),
        u("div", {
          class: "thn--tool-notification-tab",
          "data-position": P.layout.position
        }, [
          u("div", {
            class: "thn--tool-notification-tab__popup",
            "data-closed": e.value
          }, [
            t(V, { class: "thn--tool-notification-tab__back" }),
            t(L, {
              class: "thn--tool-notification-tab__steps",
              steps: o.steps,
              "has-extra-steps": o.hasSteps,
              "max-height": E.value
            }, null, 8, ["steps", "has-extra-steps", "max-height"]),
            t(A, {
              "trigger-dismiss": !1,
              onMousedown: re(s(K), ["left"]),
              onClick: s(K)
            }, null, 8, ["onMousedown", "onClick"]),
            t(v, {
              name: "fade",
              appear: "",
              onAfterEnter: _e
            }, {
              default: p(() => [
                m(t(q, { "terms-text": s(B) }, null, 8, ["terms-text"]), [
                  [h, s(b)]
                ])
              ]),
              _: 1
            })
          ], 8, Pe),
          u("div", {
            class: "thn--tool-notification-tab__tab",
            onClick: Y[0] || (Y[0] = //@ts-ignore
            (...J) => s(K) && s(K)(...J)),
            "data-show-number": e.value,
            disabled: (te = s(_)) == null ? void 0 : te.extraData.builderMode
          }, [
            t(v, { name: S.value }, {
              default: p(() => {
                var J;
                return [
                  e.value || (J = s(_)) != null && J.extraData.builderMode ? (f(), x(s(g), {
                    key: 0,
                    class: "thn--tool-notification-tab__icon"
                  })) : e.value ? D("", !0) : (f(), x(s(w), {
                    key: 1,
                    class: "thn--tool-notification-tab__icon"
                  }))
                ];
              }),
              _: 1
            }, 8, ["name"])
          ], 8, Be)
        ], 8, Ae)
      ], 64);
    };
  }
}), Le = ["data-layout-position", "data-size", "data-device"], yo = /* @__PURE__ */ T({
  __name: "Sidebar",
  props: {
    language: {},
    device: {},
    steps: {},
    hasSteps: {},
    layout: {}
  },
  setup(I, { expose: z }) {
    const o = I, e = H(), n = c(!1), i = c(!1), l = c(), d = c(), _ = a(() => {
      if (l.value) {
        const j = o.layout.position === G.Bottom ? 0.5 : 1;
        return l.value.offsetHeight * j;
      }
    }), y = a(() => o.layout.closeOnClickOutside), r = a(() => {
      switch (o.layout.position) {
        case G.Left:
          return "fade-from-left";
        case G.Right:
          return "fade-from-right";
        case G.Bottom:
        default:
          return "fade-from-bottom";
      }
    });
    O(() => {
      e == null || e.styles.addCssVariables(
        e.literals.device === $.Desktop ? {
          "--step-padding": "40px",
          "--module-margin-top": "20px",
          "--xclose-margin": "10px"
        } : {
          "--step-padding": "25px",
          "--module-margin-top": "15px",
          "--xclose-margin": "5px"
        }
      );
    });
    function g() {
      n.value = !1;
    }
    function w() {
      n.value = !0;
    }
    function C() {
      i.value = !0;
    }
    return z({
      show: g,
      hide: w
    }), (j, E) => (f(), x(v, {
      name: "fade",
      appear: "",
      onAfterEnter: C
    }, {
      default: p(() => [
        m(u("div", {
          class: "thn--tool-sidebar",
          ref_key: "rootDom",
          ref: l
        }, [
          t(F, {
            class: "thn--tool-sidebar__overlay",
            "close-on-click-outside": !!y.value
          }, null, 8, ["close-on-click-outside"]),
          t(v, { name: r.value }, {
            default: p(() => [
              m(u("div", {
                class: "thn--tool-sidebar__popup",
                ref_key: "popupDom",
                ref: d,
                "data-layout-position": o.layout.position,
                "data-size": o.layout.size,
                "data-device": o.device
              }, [
                t(V, { class: "thn--tool-sidebar__back" }),
                t(L, {
                  class: "thn--tool-sidebar__steps",
                  steps: o.steps,
                  "has-extra-steps": o.hasSteps,
                  "max-height": _.value
                }, null, 8, ["steps", "has-extra-steps", "max-height"]),
                s(b) ? D("", !0) : (f(), x(A, { key: 0 })),
                t(v, { name: "fade" }, {
                  default: p(() => [
                    m(t(q, { "terms-text": s(B) }, null, 8, ["terms-text"]), [
                      [h, s(b)]
                    ])
                  ]),
                  _: 1
                })
              ], 8, Le), [
                [h, !n.value && i.value]
              ])
            ]),
            _: 1
          }, 8, ["name"])
        ], 512), [
          [h, !n.value]
        ])
      ]),
      _: 1
    }));
  }
}), qe = ["data-size", "data-position"], Ve = { class: "thn--tool-side-gradient__content" }, Io = /* @__PURE__ */ T({
  __name: "SideGradient",
  props: {
    language: {},
    device: {},
    steps: {},
    hasSteps: {},
    layout: {}
  },
  setup(I, { expose: z }) {
    ee((r) => ({
      "2926ce74": d.value
    }));
    const o = I, e = H(), n = c(!1), i = c(), l = a(() => {
      if (i.value) {
        const r = o.layout.position === G.Bottom ? 0.5 : 1;
        return i.value.offsetHeight * r;
      }
    }), d = a(() => {
      const {
        base: r = "#ffffff",
        gradient: g
      } = (e == null ? void 0 : e.styles.colors.background) || {};
      let w;
      switch (o.layout.position) {
        case G.Bottom:
          w = 360;
          break;
        case G.Right:
          w = -90;
          break;
        default:
          w = 90;
          break;
      }
      const C = e != null && e.rtl && o.layout.position !== G.Bottom ? `${U(g || r, 0)} 0%, 
       ${U(g || r, 0.75)} 41.36%, 
       ${U(r, 0.95)} 71.2%, 
       ${r} 99.93%` : `${r} 0.07%, 
       ${U(r, 0.95)} 28.8%, 
       ${U(g || r, 0.75)} 58.64%, 
       ${U(g || r, 0)} 100%`;
      return `linear-gradient(${w}deg, ${C})`;
    });
    O(() => {
      e == null || e.styles.addCssVariables(
        e.literals.device === $.Desktop ? {
          "--step-padding": "40px",
          "--module-margin-top": "20px",
          "--xclose-margin": "10px"
        } : {
          "--step-padding": "25px",
          "--module-margin-top": "15px",
          "--xclose-margin": "5px"
        }
      );
    });
    function _() {
      n.value = !1;
    }
    function y() {
      n.value = !0;
    }
    return z({
      show: _,
      hide: y
    }), (r, g) => (f(), x(v, {
      name: "fade",
      appear: ""
    }, {
      default: p(() => [
        m(u("div", {
          class: "thn--tool-side-gradient",
          ref_key: "rootDom",
          ref: i
        }, [
          u("div", {
            class: "thn--tool-side-gradient__popup",
            "data-size": o.layout.size,
            "data-position": o.layout.position
          }, [
            u("div", Ve, [
              t(L, {
                class: "thn--tool-side-gradient__steps",
                steps: o.steps,
                "has-extra-steps": o.hasSteps,
                "max-height": l.value
              }, null, 8, ["steps", "has-extra-steps", "max-height"]),
              s(b) ? D("", !0) : (f(), x(A, {
                key: 0,
                class: "thn--tool-side-gradient__xclose"
              })),
              t(v, { name: "fade" }, {
                default: p(() => [
                  m(t(q, { "terms-text": s(B) }, null, 8, ["terms-text"]), [
                    [h, s(b)]
                  ])
                ]),
                _: 1
              })
            ])
          ], 8, qe)
        ], 512), [
          [h, !n.value]
        ])
      ]),
      _: 1
    }));
  }
}), Re = { class: "thn--tool-square__popup" }, zo = /* @__PURE__ */ T({
  __name: "Square",
  props: {
    language: {},
    device: {},
    steps: {},
    hasSteps: {},
    layout: {}
  },
  setup(I, { expose: z }) {
    const o = I, e = H(), n = c(!1), i = c(!1), l = c(), d = a(() => {
      if (l.value)
        return l.value.offsetHeight * 0.8;
    }), _ = a(() => !!o.layout.closeOnClickOutside);
    O(() => {
      e == null || e.styles.addCssVariables(
        e.literals.device === $.Desktop ? {
          "--step-padding": "40px",
          "--module-margin-top": "20px",
          "--xclose-margin": "10px"
        } : {
          "--step-padding": "25px",
          "--module-margin-top": "15px",
          "--xclose-margin": "5px"
        }
      );
    });
    function y() {
      n.value = !1;
    }
    function r() {
      n.value = !0;
    }
    function g() {
      i.value = !0;
    }
    return z({
      show: y,
      hide: r
    }), (w, C) => (f(), x(v, {
      name: "fade",
      appear: "",
      onAfterEnter: g
    }, {
      default: p(() => [
        m(u("div", {
          class: "thn--tool-square",
          ref_key: "rootDom",
          ref: l
        }, [
          t(F, {
            class: "thn--tool-square__overlay",
            "close-on-click-outside": _.value
          }, null, 8, ["close-on-click-outside"]),
          t(v, { name: "fade-from-bottom" }, {
            default: p(() => [
              m(u("div", Re, [
                t(V, { class: "thn--tool-square__back" }),
                t(L, {
                  class: "thn--tool-square__steps",
                  steps: o.steps,
                  "has-extra-steps": o.hasSteps,
                  "max-height": d.value
                }, null, 8, ["steps", "has-extra-steps", "max-height"]),
                s(b) ? D("", !0) : (f(), x(A, { key: 0 })),
                t(v, { name: "fade" }, {
                  default: p(() => [
                    m(t(q, { "terms-text": s(B) }, null, 8, ["terms-text"]), [
                      [h, s(b)]
                    ])
                  ]),
                  _: 1
                })
              ], 512), [
                [h, !n.value && i.value]
              ])
            ]),
            _: 1
          })
        ], 512), [
          [h, !n.value]
        ])
      ]),
      _: 1
    }));
  }
}), Ne = ["data-loaded"], Ge = ["src", "alt"], We = { class: "w-full h-full bg-base-300 flex items-center justify-center" }, jo = /* @__PURE__ */ T({
  __name: "SquareImage",
  props: {
    language: {},
    device: {},
    steps: {},
    hasSteps: {},
    layout: {}
  },
  setup(I, { expose: z }) {
    const o = H(), e = I, n = c(), i = c(!1), l = c(!1), d = c(!1), _ = a(() => e.layout), y = a(() => e.device), { imageUrl: r, imageAlt: g } = ze(_, y), w = a(() => {
      if (n.value) {
        const W = e.device === $.Mobile ? 0.4 : 0.8;
        return n.value.offsetHeight * W;
      }
    }), C = a(() => !!e.layout.closeOnClickOutside), j = a(() => {
      var W;
      return e.device === $.Mobile ? "top" : ((W = e.layout) == null ? void 0 : W.imagePosition) ?? "left";
    }), { imageStyles: E } = me(
      a(() => e.layout),
      a(() => e.device),
      j
    );
    O(() => {
      o == null || o.styles.addCssVariables(
        o.literals.device === $.Desktop ? {
          "--step-padding": "40px",
          "--module-margin-top": "20px",
          "--xclose-margin": "10px"
        } : {
          "--step-padding": "25px",
          "--module-margin-top": "15px",
          "--xclose-margin": "5px"
        }
      ), r.value || (i.value = !1);
    });
    function S() {
      l.value = !1;
    }
    function M() {
      l.value = !0;
    }
    function k() {
      d.value = !0;
    }
    function R() {
      i.value = !0;
    }
    return z({
      show: S,
      hide: M
    }), (W, K) => (f(), x(v, {
      name: "fade",
      onAfterEnter: k,
      appear: ""
    }, {
      default: p(() => [
        m(u("div", {
          class: "thn--tool-square-image",
          ref_key: "rootDom",
          ref: n
        }, [
          t(F, {
            class: "thn--tool-square-image__overlay",
            "close-on-click-outside": C.value
          }, null, 8, ["close-on-click-outside"]),
          t(v, { name: "fade-from-bottom" }, {
            default: p(() => [
              m(u("div", {
                class: Q([
                  "thn--tool-square-image__popup",
                  j.value
                ])
              }, [
                s(E) ? (f(), x(V, {
                  key: 0,
                  class: "thn--tool-square-image__back"
                })) : D("", !0),
                u("div", {
                  class: Q([
                    "thn--tool-square-image__popup__wrapper",
                    j.value
                  ])
                }, [
                  u("div", {
                    class: "thn--tool-square-image__image",
                    style: ue(s(E)),
                    "data-loaded": i.value
                  }, [
                    t(ce, { name: "fade" }, {
                      default: p(() => [
                        m(u("img", {
                          ref: "imageDOM",
                          src: s(r),
                          onLoad: R,
                          alt: s(g)
                        }, null, 40, Ge), [
                          [h, i.value]
                        ]),
                        m(u("div", We, [
                          t(s(he), { class: "img-icon" })
                        ], 512), [
                          [h, !i.value]
                        ])
                      ]),
                      _: 1
                    })
                  ], 12, Ne),
                  u("div", {
                    class: Q(["thn--tool-square-image__content", [{ relative: i.value }]])
                  }, [
                    s(E) ? D("", !0) : (f(), x(V, {
                      key: 0,
                      class: "thn--tool-square-image__back"
                    })),
                    t(L, {
                      class: "thn--tool-square-image__steps",
                      steps: e.steps,
                      "has-extra-steps": e.hasSteps,
                      "max-height": w.value,
                      "layout-kind": s(de).SquareImage
                    }, null, 8, ["steps", "has-extra-steps", "max-height", "layout-kind"])
                  ], 2),
                  s(b) ? D("", !0) : (f(), x(A, { key: 0 })),
                  t(v, { name: "fade" }, {
                    default: p(() => [
                      m(t(q, { "terms-text": s(B) }, null, 8, ["terms-text"]), [
                        [h, s(b)]
                      ])
                    ]),
                    _: 1
                  })
                ], 2)
              ], 2), [
                [h, !l.value && d.value]
              ])
            ]),
            _: 1
          })
        ], 512), [
          [h, !l.value]
        ])
      ]),
      _: 1
    }));
  }
}), Fe = ["data-position", "data-size"], bo = /* @__PURE__ */ T({
  __name: "Sticky",
  props: {
    language: {},
    device: {},
    steps: {},
    hasSteps: {},
    layout: {}
  },
  setup(I, { expose: z }) {
    const o = I, e = H(), n = c(!1), i = c(!1), l = c(), d = a(() => {
      if (l.value)
        return l.value.offsetHeight * 0.6;
    });
    a(() => !!o.layout.closeOnClickOutside);
    const _ = a(() => {
      const { position: w } = o.layout;
      return w ? `fade-from-${w.slice(-1) === "L" ? "left" : "right"}` : "fade";
    });
    O(() => {
      e == null || e.styles.addCssVariables(
        e.literals.device === $.Desktop ? {
          "--step-padding": "24px",
          "--module-margin-top": "10px",
          "--xclose-margin": "5px"
        } : {
          "--step-padding": "24px",
          "--module-margin-top": "8px",
          "--xclose-margin": "5px"
        }
      );
    });
    function y() {
      n.value = !1;
    }
    function r() {
      n.value = !0;
    }
    function g() {
      i.value = !0;
    }
    return z({
      show: y,
      hide: r
    }), (w, C) => (f(), x(v, {
      name: "fade",
      appear: "",
      onAfterEnter: g
    }, {
      default: p(() => [
        m(u("div", {
          class: "thn--tool-sticky",
          ref_key: "rootDom",
          ref: l
        }, [
          t(v, { name: _.value }, {
            default: p(() => [
              m(u("div", {
                class: "thn--tool-sticky__popup",
                "data-position": w.layout.position,
                "data-size": o.layout.size
              }, [
                t(V, { class: "thn--tool-sticky__back" }),
                t(L, {
                  class: "thn--tool-sticky__steps",
                  steps: o.steps,
                  "has-extra-steps": o.hasSteps,
                  "max-height": d.value
                }, null, 8, ["steps", "has-extra-steps", "max-height"]),
                s(b) ? D("", !0) : (f(), x(A, { key: 0 })),
                t(v, { name: "fade" }, {
                  default: p(() => [
                    m(t(q, { "terms-text": s(B) }, null, 8, ["terms-text"]), [
                      [h, s(b)]
                    ])
                  ]),
                  _: 1
                })
              ], 8, Fe), [
                [h, !n.value && i.value]
              ])
            ]),
            _: 1
          }, 8, ["name"])
        ], 512), [
          [h, !n.value]
        ])
      ]),
      _: 1
    }));
  }
}), Ue = ["data-device", "data-position", "data-size", "data-image-position"], Ke = { class: "thn--tool-sticky-image__popup__wrapper" }, Xe = ["data-loaded"], Ye = ["src", "alt"], Je = { class: "w-full h-full bg-base-300 flex items-center justify-center" }, Co = /* @__PURE__ */ T({
  __name: "StickyImage",
  props: {
    language: {},
    device: {},
    steps: {},
    hasSteps: {},
    layout: {}
  },
  setup(I, { expose: z }) {
    const o = I;
    ge("layout", c(o.layout));
    const e = H(), n = c(!1), i = c(!1), l = c(!1), d = c(), _ = a(() => {
      var k;
      return (k = o.layout) != null && k.image ? e == null ? void 0 : e.literals.getLocaleImageUrl(o.layout.image) : "";
    }), y = a(() => {
      var k;
      return (k = o.layout) != null && k.image ? e == null ? void 0 : e.literals.getLocaleImageAlt(o.layout.image) : "";
    }), r = a(() => {
      if (d.value)
        return d.value.offsetHeight * 0.6;
    }), g = a(() => {
      const { position: k } = o.layout;
      return k ? `fade-from-${k.slice(-1) === "L" ? "left" : "right"}` : "fade";
    }), w = a(() => {
      var k;
      return ((k = o.layout) == null ? void 0 : k.imagePosition) ?? "left";
    }), { imageStyles: C } = me(
      a(() => o.layout),
      a(() => o.device),
      w
    );
    O(() => {
      e == null || e.styles.addCssVariables(
        e.literals.device === $.Desktop ? {
          "--step-padding": "16px",
          "--module-margin-top": "10px",
          "--xclose-margin": "5px"
        } : {
          "--step-padding": "16px",
          "--module-margin-top": "8px",
          "--xclose-margin": "5px"
        }
      ), _.value || (i.value = !1);
    });
    function j() {
      n.value = !1;
    }
    function E() {
      n.value = !0;
    }
    function S() {
      l.value = !0;
    }
    function M() {
      i.value = !0;
    }
    return z({
      show: j,
      hide: E
    }), (k, R) => (f(), x(v, {
      name: "fade",
      appear: "",
      onAfterEnter: S
    }, {
      default: p(() => [
        m(u("div", {
          class: "thn--tool-sticky-image",
          ref_key: "rootDom",
          ref: d
        }, [
          t(v, { name: g.value }, {
            default: p(() => [
              m(u("div", {
                class: "thn--tool-sticky-image__popup",
                "data-device": k.device,
                "data-position": k.layout.position,
                "data-size": o.layout.size,
                "data-image-position": w.value
              }, [
                u("div", Ke, [
                  s(C) ? (f(), x(V, {
                    key: 0,
                    class: "thn--tool-square-image__back"
                  })) : D("", !0),
                  u("div", {
                    class: "thn--tool-sticky-image__image",
                    style: ue(s(C)),
                    "data-loaded": i.value
                  }, [
                    t(ce, { name: "fade" }, {
                      default: p(() => [
                        m(u("img", {
                          ref: "imageDOM",
                          src: _.value,
                          onLoad: M,
                          alt: y.value
                        }, null, 40, Ye), [
                          [h, i.value]
                        ]),
                        m(u("div", Je, [
                          t(s(he), { class: "img-icon" })
                        ], 512), [
                          [h, !i.value]
                        ])
                      ]),
                      _: 1
                    })
                  ], 12, Xe),
                  u("div", {
                    class: Q(["thn--tool-sticky-image__content", [{ relative: i.value }]])
                  }, [
                    s(C) ? D("", !0) : (f(), x(V, {
                      key: 0,
                      class: "thn--tool-square-image__back"
                    })),
                    t(L, {
                      class: "thn--tool-sticky-image__steps",
                      steps: o.steps,
                      "has-extra-steps": o.hasSteps,
                      "max-height": r.value
                    }, null, 8, ["steps", "has-extra-steps", "max-height"])
                  ], 2),
                  s(b) ? D("", !0) : (f(), x(A, { key: 1 }))
                ]),
                t(v, { name: "fade" }, {
                  default: p(() => [
                    m(t(q, { "terms-text": s(B) }, null, 8, ["terms-text"]), [
                      [h, s(b)]
                    ])
                  ]),
                  _: 1
                })
              ], 8, Ue), [
                [h, !n.value && l.value]
              ])
            ]),
            _: 1
          }, 8, ["name"])
        ], 512), [
          [h, !n.value]
        ])
      ]),
      _: 1
    }));
  }
});
export {
  fo as C,
  vo as _,
  go as a,
  ko as b,
  xo as c,
  wo as d,
  yo as e,
  Io as f,
  zo as g,
  jo as h,
  bo as i,
  Co as j
};
//# sourceMappingURL=StickyImage.vue_vue_type_style_index_0_lang.BECXCKCu.js.map
